import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import fr from '../locales/vuetify-fr'
import en from '../locales/vuetify-en'
import de from '../locales/vuetify-de'
import lb from '../locales/vuetify-lb'

// define a new console
var console = (function (oldCons) {
  return {
    log: function (text) {
      oldCons.log(text);
      // Your code
    },
    info: function (text) {
      oldCons.info(text);
      // Your code
    },
    warn: function (text) {//For useless deprecated warnings
      //oldCons.warn(text);
      // Your code
      return text;
    },
    error: function (text) {
      oldCons.error(text);
      // Your code
    }
  };
}(window.console));

//Then redefine the old console
window.console = console;

Vue.use(Vuetify, {
  iconfont: 'mdi',
  lang: {
    locales: { fr, en, de, lb },
    current: 'fr',
  },
  theme: {
    primary: '#2E3B7F',
    secondary: '#589C8F',
    accent: '#6DC5D4',
    error: '#F5786A',
    info: '#2196F3',
    success: '#71DBBA',
    warning: '#FFC107'
  }
});
